module.exports = __webpack_public_path__ + "static/media/leavebed.399aa793.png";